import { AgentChat } from './AgentChat';
import { ResponsiveLayout } from './ui/ResponsiveLayout';

export const AgentChatWithLeftSidebar = ({
  matterId,
  workspaceId,
  viewMode,
  onToolCall,
  initialThreadId,
  onDeeplinkConsumed,
}: {
  matterId: string;
  workspaceId?: string;
  viewMode?: 'compact' | 'fullscreen';
  onToolCall?: (toolName: string, input: unknown, output?: unknown) => void;
  initialThreadId?: string | null;
  onDeeplinkConsumed?: () => void;
}) => {
  return (
    <AgentChat
      matterId={matterId}
      workspaceId={workspaceId}
      viewMode={viewMode}
      onToolCall={onToolCall}
      initialThreadId={initialThreadId}
      onDeeplinkConsumed={onDeeplinkConsumed}
    >
      <ResponsiveLayout
        sidebar={<AgentChat.ThreadList />}
        content={<AgentChat.Content />}
      />
    </AgentChat>
  );
};

export const AgentChatWithTabs = ({
  matterId,
  workspaceId,
  onToolCall,
}: {
  matterId: string;
  workspaceId?: string;
  onToolCall?: (toolName: string, input: unknown, output?: unknown) => void;
}) => {
  return (
    <AgentChat matterId={matterId} workspaceId={workspaceId} onToolCall={onToolCall}>
      <div className="flex flex-col h-full w-full">
        <div className="sticky top-0 border-b min-h-[37px] shadow-md">
          <AgentChat.ThreadListTabs />
        </div>
        <div className="h-full overflow-y-auto">
          <AgentChat.Content />
        </div>
      </div>
    </AgentChat>
  );
};
